import React from 'react';
import { Embed } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/embed.less';

export default Embed;
